module.exports = __webpack_public_path__ + "media/images/icons/message-dark-c3b14496078a2a055e0dd8335e6f9558.svg";